import {
  Components,
  createTheme,
  PaletteColor,
  PaletteColorOptions,
  PaletteOptions,
} from "@mui/material/styles";
import { projectTypography } from "./typography";

export type AllowedTheme = NonNullable<PaletteOptions["mode"]>;

export const DEFAULT_THEME: AllowedTheme = "dark";

export const THEME_VALUES = {
  dark: "dark",
  light: "light",
};

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    d1Regular: true;
    d2Regular: true;
    d3Regular: true;
    h1Regular: true;
    h2Regular: true;
    h3Regular: true;
    h4Regular: true;
    h5Regular: true;
    h6Regular: true;
    captionRegular: true;
    footerRegular: true;
    labelRegular: true;
    warningRegular: true;

    // 500
    d1MediumBold: true;
    d2MediumBold: true;
    d3MediumBold: true;
    h1MediumBold: true;
    h2MediumBold: true;
    h3MediumBold: true;
    h4MediumBold: true;
    h5MediumBold: true;
    h6MediumBold: true;

    captionMediumBold: true;
    footerMediumBold: true;
    labelMediumBold: true;
    warningMediumBold: true;

    d1DemiBold: true;
    d2DemiBold: true;
    d3DemiBold: true;
    h1DemiBold: true;
    h2DemiBold: true;
    h3DemiBold: true;
    h4DemiBold: true;
    h5DemiBold: true;
    h6DemiBold: true;

    captionDemiBold: true;
    footerDemiBold: true;
    labelDemiBold: true;
    warningDemiBold: true;

    // 700
    d1Bold: true;
    d2Bold: true;
    d3Bold: true;
    h1Bold: true;
    h2Bold: true;
    h3Bold: true;
    h4Bold: true;
    h5Bold: true;
    h6Bold: true;

    captionBold: true;
    footerBold: true;
    labelBold: true;
    warningBold: true;
    // 800
    d1ExtraBold: true;
    d2ExtraBold: true;
    d3ExtraBold: true;
    h1ExtraBold: true;
    h2ExtraBold: true;
    h3ExtraBold: true;
    h4ExtraBold: true;
    h5ExtraBold: true;
    h6ExtraBold: true;

    captionExtraBold: true;
    footerExtraBold: true;
    labelExtraBold: true;
    warningExtraBold: true;

    // 900
    d1Black: true;
    d2Black: true;
    d3Black: true;
    h1Black: true;
    h2Black: true;
    h3Black: true;
    h4Black: true;
    h5Black: true;
    h6Black: true;

    captionBlack: true;
    footerBlack: true;
    labelBlack: true;
    warningBlack: true;
  }
}

interface ProjectPaletteColor {
  100: string;
  200: string;
  300: string;
  400: string;
  600: string;
  700: string;
  800: string;
  900: string;
  main: string;
}

interface GrayPaletteColor {
  100: string;
  200: string;
  300: string;
  400: string;
  50: string;
  bg: string;
}
interface DarkPaletteColor {
  40: string;
  30: string;
  20: string;
  10: string;
}
interface SatisfactionPaletteColor {
  100: string;
  95: string;
  90: string;
  85: string;
  80: string;
  60: string;
}

 interface OthersPaletteColor {
  link: string;
  bg: string;
  activeBg: string;
  active: string;
  doneBg: string;
  done: string;
  pendingBg: string;
  pending: string;
  deadlineBg: string;
  deadline: string;
  borderColor: string;
  borderColor2: string;
  paymentBg: string;
  purple:string
}

declare module "@mui/material/styles" {
  interface TypographyVariants {
    d1Regular: React.CSSProperties;
    d2Regular: React.CSSProperties;
    d3Regular: React.CSSProperties;
    h1Regular: React.CSSProperties;
    h2Regular: React.CSSProperties;
    h3Regular: React.CSSProperties;
    h4Regular: React.CSSProperties;
    h5Regular: React.CSSProperties;
    h6Regular: React.CSSProperties;
    captionRegular: React.CSSProperties;
    footerRegular: React.CSSProperties;
    labelRegular: React.CSSProperties;
    warningRegular: React.CSSProperties;

    // 500
    d1MediumBold: React.CSSProperties;
    d2MediumBold: React.CSSProperties;
    d3MediumBold: React.CSSProperties;
    h1MediumBold: React.CSSProperties;
    h2MediumBold: React.CSSProperties;
    h3MediumBold: React.CSSProperties;
    h4MediumBold: React.CSSProperties;
    h5MediumBold: React.CSSProperties;
    h6MediumBold: React.CSSProperties;

    captionMediumBold: React.CSSProperties;
    footerMediumBold: React.CSSProperties;
    labelMediumBold: React.CSSProperties;
    warningMediumBold: React.CSSProperties;

    d1DemiBold: React.CSSProperties;
    d2DemiBold: React.CSSProperties;
    d3DemiBold: React.CSSProperties;
    h1DemiBold: React.CSSProperties;
    h2DemiBold: React.CSSProperties;
    h3DemiBold: React.CSSProperties;
    h4DemiBold: React.CSSProperties;
    h5DemiBold: React.CSSProperties;
    h6DemiBold: React.CSSProperties;

    captionDemiBold: React.CSSProperties;
    footerDemiBold: React.CSSProperties;
    labelDemiBold: React.CSSProperties;
    warningDemiBold: React.CSSProperties;

    // 700
    d1Bold: React.CSSProperties;
    d2Bold: React.CSSProperties;
    d3Bold: React.CSSProperties;
    h1Bold: React.CSSProperties;
    h2Bold: React.CSSProperties;
    h3Bold: React.CSSProperties;
    h4Bold: React.CSSProperties;
    h5Bold: React.CSSProperties;
    h6Bold: React.CSSProperties;

    captionBold: React.CSSProperties;
    footerBold: React.CSSProperties;
    labelBold: React.CSSProperties;
    warningBold: React.CSSProperties;
    // 800
    d1ExtraBold: React.CSSProperties;
    d2ExtraBold: React.CSSProperties;
    d3ExtraBold: React.CSSProperties;
    h1ExtraBold: React.CSSProperties;
    h2ExtraBold: React.CSSProperties;
    h3ExtraBold: React.CSSProperties;
    h4ExtraBold: React.CSSProperties;
    h5ExtraBold: React.CSSProperties;
    h6ExtraBold: React.CSSProperties;

    captionExtraBold: React.CSSProperties;
    footerExtraBold: React.CSSProperties;
    labelExtraBold: React.CSSProperties;
    warningExtraBold: React.CSSProperties;

    // 900
    d1Black: React.CSSProperties;
    d2Black: React.CSSProperties;
    d3Black: React.CSSProperties;
    h1Black: React.CSSProperties;
    h2Black: React.CSSProperties;
    h3Black: React.CSSProperties;
    h4Black: React.CSSProperties;
    h5Black: React.CSSProperties;
    h6Black: React.CSSProperties;

    captionBlack: React.CSSProperties;
    footerBlack: React.CSSProperties;
    labelBlack: React.CSSProperties;
    warningBlack: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    d1Regular?: React.CSSProperties;
    d2Regular?: React.CSSProperties;
    d3Regular?: React.CSSProperties;
    h1Regular?: React.CSSProperties;
    h2Regular?: React.CSSProperties;
    h3Regular?: React.CSSProperties;
    h4Regular?: React.CSSProperties;
    h5Regular?: React.CSSProperties;
    h6Regular?: React.CSSProperties;
    captionRegular?: React.CSSProperties;
    footerRegular?: React.CSSProperties;
    labelRegular?: React.CSSProperties;
    warningRegular?: React.CSSProperties;

    // 500
    d1MediumBold?: React.CSSProperties;
    d2MediumBold?: React.CSSProperties;
    d3MediumBold?: React.CSSProperties;
    h1MediumBold?: React.CSSProperties;
    h2MediumBold?: React.CSSProperties;
    h3MediumBold?: React.CSSProperties;
    h4MediumBold?: React.CSSProperties;
    h5MediumBold?: React.CSSProperties;
    h6MediumBold?: React.CSSProperties;

    captionMediumBold?: React.CSSProperties;
    footerMediumBold?: React.CSSProperties;
    labelMediumBold?: React.CSSProperties;
    warningMediumBold?: React.CSSProperties;

    d1DemiBold?: React.CSSProperties;
    d2DemiBold?: React.CSSProperties;
    d3DemiBold?: React.CSSProperties;
    h1DemiBold?: React.CSSProperties;
    h2DemiBold?: React.CSSProperties;
    h3DemiBold?: React.CSSProperties;
    h4DemiBold?: React.CSSProperties;
    h5DemiBold?: React.CSSProperties;
    h6DemiBold?: React.CSSProperties;

    captionDemiBold?: React.CSSProperties;
    footerDemiBold?: React.CSSProperties;
    labelDemiBold?: React.CSSProperties;
    warningDemiBold?: React.CSSProperties;

    // 700
    d1Bold?: React.CSSProperties;
    d2Bold?: React.CSSProperties;
    d3Bold?: React.CSSProperties;
    h1Bold?: React.CSSProperties;
    h2Bold?: React.CSSProperties;
    h3Bold?: React.CSSProperties;
    h4Bold?: React.CSSProperties;
    h5Bold?: React.CSSProperties;
    h6Bold?: React.CSSProperties;

    captionBold?: React.CSSProperties;
    footerBold?: React.CSSProperties;
    labelBold?: React.CSSProperties;
    warningBold?: React.CSSProperties;
    // 800
    d1ExtraBold?: React.CSSProperties;
    d2ExtraBold?: React.CSSProperties;
    d3ExtraBold?: React.CSSProperties;
    h1ExtraBold?: React.CSSProperties;
    h2ExtraBold?: React.CSSProperties;
    h3ExtraBold?: React.CSSProperties;
    h4ExtraBold?: React.CSSProperties;
    h5ExtraBold?: React.CSSProperties;
    h6ExtraBold?: React.CSSProperties;

    captionExtraBold?: React.CSSProperties;
    footerExtraBold?: React.CSSProperties;
    labelExtraBold?: React.CSSProperties;
    warningExtraBold?: React.CSSProperties;

    // 900
    d1Black?: React.CSSProperties;
    d2Black?: React.CSSProperties;
    d3Black?: React.CSSProperties;
    h1Black?: React.CSSProperties;
    h2Black?: React.CSSProperties;
    h3Black?: React.CSSProperties;
    h4Black?: React.CSSProperties;
    h5Black?: React.CSSProperties;
    h6Black?: React.CSSProperties;

    captionBlack?: React.CSSProperties;
    footerBlack?: React.CSSProperties;
    labelBlack?: React.CSSProperties;
    warningBlack?: React.CSSProperties;
  }

  interface PaletteOptions {
    gradient?: string;
    white?: PaletteColorOptions;
    black?: PaletteColorOptions;
    gray?: any;
    purple?: PaletteColorOptions;
    tertiary?: PaletteColorOptions;
    dominant?: PaletteColorOptions;
    complement?: PaletteColorOptions;
    accent?: PaletteColorOptions;
    dark?: any;
    satisfaction?: any;
    others?: any;
  }
  interface Palette {
    gradient?: string;
    white?: PaletteColor;
    black?: PaletteColor;
    purple?: PaletteColor;
    tertiary?: PaletteColor;
    gray: GrayPaletteColor;
    dominant: ProjectPaletteColor;
    complement: ProjectPaletteColor;
    accent: ProjectPaletteColor;
    dark: DarkPaletteColor;
    satisfaction: SatisfactionPaletteColor;
    others: OthersPaletteColor;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    danger: true;
    dangerOutlined: true;
    success: true;
    active: true;
    activeOutlined: true;
    confirm: true;
    confirmOutlined: true;
    activeText: true;
    activeText2: true;
    outlinedText: true;
  }
}

const MuiButton: NonNullable<Components["MuiButton"]> = {
  styleOverrides: {
    // Styles for the contained button variant
    root: {
      backgroundColor: "#0f4c75", // Default color
      color: "#EDF4F8",
      "&:hover": {
        backgroundColor: "#092d46", // Hover color
      },
      "&:disabled": {
        backgroundColor: "#ebebeb",
        color: "#555",
        borderColor: "#ebebeb",
      },
    },
    contained: {
      boxShadow: "none",
      backgroundColor: "#0f4c75", // Default color
      color: "#EDF4F8",
      "&:hover": {
        backgroundColor: "#092d46", // Hover color
      },
      "&:disabled": {
        borderColor: "#ebebeb",
        backgroundColor: "#ebebeb",
        color: "#555",
      },
    },

    // Styles for the outlined button variant
    outlined: {
      boxShadow: "none",
      borderColor: "#0f4c75",
      color: "#0f4c75",
      fontWeight: "500",
      fontSize: "14.22px",
      lineHeight: "27.02px",
      backgroundColor: "#fafafa",
      "&:hover": {
        borderColor: "#0f4c75",
        backgroundColor: "#a0b8c8",
        color: "#030f17",
      },
      "&:disabled": {
        borderColor: "#ebebeb",
        backgroundColor: "#ebebeb",
        color: "#555",
      },
    },
    // Styles for the text button variant
    text: {
      boxShadow: "none",
      color: "#4d4d4d",
      fontWeight: "500",
      fontSize: "14.22px",
      lineHeight: "27.02px",
      backgroundColor: "#f5f5f5",
      "&:hover": {
        backgroundColor: "#e1e1e1", // Slight background change on hover
      },
      "&:disabled": {
        borderColor: "#ebebeb",
        backgroundColor: "#ebebeb",
        color: "#555",
      },
    },
  },
  // Adding custom variants
  variants: [
    {
      props: { variant: "outlinedText" },
      style: {
        borderColor: "#3C9A4F",
        padding: "9px, 18px, 9px, 18px",
        fontWeight: "500",
        fontSize: "14.22px",
        lineHeight: "27.02px",

        backgroundColor: "transparent", // Default color
        color: "#000",
        border: "0.8px solid #00000023",
        "&:hover": {
          borderColor: "#0088ff",
          backgroundColor: "#ebf5ff",
        },
        "&:disabled": {
          borderColor: "#ebebeb",
          backgroundColor: "#ebebeb",
          color: "#555",
        },
      },
    },
    {
      props: { variant: "confirm" },
      style: {
        color: "#fafafa",
        backgroundColor: "#3C9A4F",
        borderColor: "#3C9A4F",
        padding: "9px, 18px, 9px, 18px",
        fontWeight: "500",
        fontSize: "14.22px",
        lineHeight: "27.02px",
        "&:hover": {
          borderColor: "#3C9A4F",
          backgroundColor: "#378c48",
        },
        "&:disabled": {
          borderColor: "#ebebeb",
          backgroundColor: "#ebebeb",
          color: "#555",
        },
      },
    },

    {
      props: { variant: "confirmOutlined" },
      style: {
        color: "#3C9A4F",
        backgroundColor: "#f0faf2",
        borderColor: "#3C9A4F",
        border: "1px solid #3c9a4f",
        padding: "9px, 18px, 9px, 18px",
        fontWeight: "500",
        fontSize: "14.22px",
        lineHeight: "27.02px",
        "&:hover": {
          borderColor: "#3C9A4F",
          backgroundColor: "#bef5c9",
          color: "#3C9A4F",
        },
        "&:disabled": {
          borderColor: "#ebebeb",
          backgroundColor: "#ebebeb",
          color: "#555",
        },
      },
    },

    {
      props: { variant: "activeText2" },
      style: {
        color: "#0088ff",
        backgroundColor: "transparent",
        padding: "9px, 18px, 9px, 18px",
        fontWeight: "500",
        fontSize: "14.22px",
        lineHeight: "27.02px",
        "&:hover": {
          borderColor: "#0088ff",
          outline: "1px solid #0088ff",
          backgroundColor: "#ebf5ff",
          color: "#0088ff",
        },
        "&:disabled": {
          borderColor: "#ebebeb",
          backgroundColor: "#ebebeb",
          color: "#555",
        },
      },
    },
    {
      props: { variant: "activeText" },
      style: {
        color: "#0088ff",
        backgroundColor: "#ebf5ff",
        padding: "9px, 18px, 9px, 18px",
        fontWeight: "500",
        fontSize: "14.22px",
        lineHeight: "27.02px",
        "&:hover": {
          borderColor: "#0088ff",
          outline: "1px solid #0088ff",
          backgroundColor: "#ebf5ff",
          color: "#0088ff",
        },
        "&:disabled": {
          borderColor: "#ebebeb",
          backgroundColor: "#ebebeb",
          color: "#555",
        },
      },
    },
    {
      props: { variant: "active" },
      style: {
        color: "#ebf5ff",
        border: "1px solid #0088ff",
        backgroundColor: "#0088FF",
        padding: "9px, 18px, 9px, 18px",
        fontWeight: "500",
        fontSize: "14.22px",
        lineHeight: "27.02px",
        "&:hover": {
          borderColor: "#0088ff",
          border: "1px solid #0088ff",
          backgroundColor: "#0175da",
          color: "#ebf5ff",
        },
        "&:disabled": {
          borderColor: "#ebebeb",
          backgroundColor: "#ebebeb",
          color: "#555",
        },
      },
    },
    {
      props: { variant: "activeOutlined" },
      style: {
        color: "#0088FF",
        border: "1px solid #0088ff",
        backgroundColor: "#ebf5ff",
        padding: "9px, 18px, 9px, 18px",
        fontWeight: "500",
        fontSize: "14.22px",
        lineHeight: "27.02px",
        "&:hover": {
          borderColor: "#0088ff",
          border: "1px solid #0088ff",
          backgroundColor: "#cce6ff",
          color: "#1a1a1a",
        },
        "&:disabled": {
          borderColor: "#ebebeb",
          backgroundColor: "#ebebeb",
          color: "#555",
        },
      },
    },

    {
      props: { variant: "dangerOutlined" },
      style: {
        border: "1px solid #fc4d55",
        color: "#fc4d55",
        backgroundColor: "#ffebeb",
        "&:hover": {
          borderColor: "#fc4d55",
          backgroundColor: "#ffcdcd",
        },
        "&:disabled": {
          borderColor: "#ebebeb",
          backgroundColor: "#ebebeb",
          color: "#555",
        },
      },
    },
    {
      props: { variant: "danger" },
      style: {
        border: "1px solid #fc4d55",
        color: "#ffebeb",
        backgroundColor: "#fc4d55",
        "&:hover": {
          borderColor: "#fc4d55",
          backgroundColor: "#e23d45",
        },
        "&:disabled": {
          borderColor: "#ebebeb",
          backgroundColor: "#ebebeb",
          color: "#555",
        },
      },
    },
    {
      props: { variant: "success" },
      style: {
        backgroundColor: "#4caf50",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#388e3c",
        },
        "&:disabled": {
          borderColor: "#ebebeb",
          backgroundColor: "#ebebeb",
          color: "#555",
        },
      },
    },
  ],
};

export const lightTheme = createTheme({
  typography: {
    ...projectTypography,

    fontFamily: "IRANYekanX, Arial",
  },
  palette: {
    primary: {
      main: "#0f4c75",
    },
    mode: "light",
    dominant: {
      100: "#eef3f6",
      200: "#b7bdc1",
      300: "#80878c",
      400: "#495157",
      main: "#121b22",
      600: "#0f191d",
      700: "#0d1519",
      800: "#0b1115",
      900: "#090d11",
    },
    complement: {
      100: "#edf4f8",
      200: "#bac9cf",
      300: "#879ca6",
      400: "#546f7d",
      main: "#214254",
      600: "#1c3545",
      700: "#152834",
      800: "#0e1b23",
      900: "#070e12",
    },
    accent: {
      100: "#d0dce4",
      200: "#a0b8c8",
      300: "#6f94ac",
      400: "#3f7091",
      main: "#0f4c75",
      600: "#0c3d5d",
      700: "#092d46",
      800: "#061e2e",
      900: "#030f17",
    },
    gray: {
      bg: "#fafafa",
      50: "#ffffff",
      100: "#f5f5f5",
      200: "#ebebeb",
      300: "#e1e1e1",
      400: "#d7d7d7",
    },
    dark: {
      40: "#666666",
      30: "#4d4d4d",
      20: "#333333",
      10: "#1a1a1a",
    },
    satisfaction: {
      100: "#14341b",
      95: "#21562d",
      90: "#2e783f",
      85: "#3c9a4f",
      80: "#ffa200",
      60: "#d61600",
    },
    others: {
      link: "#2b93f3",
      bg: "#f5f8fa",
      activeBg: "#ebf5ff",
      active: "#0088ff",
      doneBg: "#f0faf2",
      done: "#3c9a4f",
      pendingBg: "#fffbeb",
      pending: "#ffc107",
      deadlineBg: "#ffebeb",
      deadline: "#fc4d55",
      borderColor: "#ECEFF1",
      borderColor2: "#AFAFAF",
      paymentBg: "#f6f6f6",
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          textAlign: "right",
          direction: "rtl",
        },
      },
    },

    MuiTypography: {
      styleOverrides: {
        root: {
          width: "fit-content",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          paddingRight: '11px !important',
          paddingLeft: '32px',
        },
        icon: {
          right: "auto",
          left: 7, 
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          fontSize: "16px",
          fontWeight: "600",
          padding: "12px 16px",
        },
        filled: {
          fontWeight: "bold",
        },
        filledSuccess: {
          backgroundColor: "#4caf50",
          color: "#ffffff",
          border: "2px solid #2e7d32",
        },
        filledError: {
          backgroundColor: "#f44336",
          color: "#ffffff",
          border: "2px solid #d32f2f",
        },
        outlinedSuccess: {
          color: "#3c9a4f",
          border: "1px solid #3c9a4f",
          backgroundColor: "#f0faf2",
        },
        outlinedError: {
          color: "#fc4d55",
          border: "1px solid #fc4d55",
          backgroundColor: "#ffebeb",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'IRANYekanX';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Raleway'), local('Raleway-Regular'), url(${"../styles/fonts/woff2/IRANYekanX-Black.woff2"}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },

    MuiInputBase: {
      styleOverrides: {
        input: {
          padding: "11px", // Removes the padding
          // backgroundColor: "var(--gray-bg)",
          fontSize: "13.17px",
          "&:focus": {
            outline: ".4px solid var(--accent-primary)",
            borderRadius: "4px",
            backgroundColor: "var(--gray-100)", // Color when focused
          },
          // "&:hover": {
          //   backgroundColor: "var(--gray-100)", // Hover color
          //   outline: ".8px solid var(--accent-primary)",
          //   border: "none",
          // },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--gray-400)	",
          },
          // Border color when focused
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--accent-primary)", // Change this to your desired color
            outlineWidth: ".4px",
            borderStyle: "solid",
            // backgroundColor: "var(--gray-100)", // Color when focused
          },
        },
        input: {
          padding: "11px", // Removes the padding
          // backgroundColor: "var(--gray-bg)",
          fontSize: "13.17px",
          "&:focus": {
            // outline: ".8px solid var(--accent-primary)",
            borderRadius: "4px",
            backgroundColor: "var(--gray-100)", // Color when focused
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "var(--gray-bg)",
            padding: "0 0",
            fontSize: "11.24px",
            fontWeight: "400",
            border: "none",
            borderRadius: "4px",
            borderColor: "var(--gray-bg)",
            "&::placeholder": {
              fontSize: "13px",
            },
            "&:hover": {
              backgroundColor: "var(--gray-100)", // Hover color
              outline: ".8px solid var(--dominant-primary)",
              border: "none",
            },
            "&.Mui-focused": {
              backgroundColor: "var(--gray-100)", // Color when focused
              outline: ".8px solid var(--accent-primary)",
              border: "none",
              outlineRadius: "4px",
            },
          },

          "& .MuiInputLabel-root.Mui-error": {
            color: "var(--satisfaction-60)",
          },
          "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
            {
              border: "1px solid var(--satisfaction-60)",
            },
          "& .MuiFormHelperText-root.Mui-error": {
            color: "var(--satisfaction-60)",
          },

          "& .MuiInputLabel-root": {
            borderColor: "var(--accent-primary)",
            background: "var(--gray-bg)",
          },
        },
      },
    },
    // MuiContainer: {
    // 	styleOverrides: {
    // 		root: {
    // 			maxWidth: "1440px !important",
    // 		},
    // 	},
    // },
    // MuiCard: {
    // 	styleOverrides: {
    // 		root: {
    // 			borderColor: "var(--accent-primary)",
    // 			background: "var(--accent-primary)",
    // 			borderWidth: 1,
    // 			borderStyle: "solid",
    // 		},
    // 	},
    // },
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: "var(--gray-50)",
        },
        indicator: {
          backgroundColor: "var(--dominant-primary)", // The color of the indicator (underline)
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "11.24px",
          fontWeight: "500",
          textTransform: "none", // Prevent text from being uppercase
          minHeight: "48px",
          "&.Mui-selected": {
            color: "var(--dark-40)", // Color when the tab is selected
            backgroundColor: "var(--gray-50)",
            fontWeight: "bold",
            border: "none",
          },
          "&:hover": {
            color: "var(--dominant-400)", // Color on hover
          },
        },
      },
    },

    MuiButton: MuiButton,
  },
});

export const darkTheme = createTheme({
  typography: {
    ...projectTypography,

    fontFamily: "IRANYekanX, Arial",
  },
  palette: {
    primary: {
      main: "#cfd604",
    },
    mode: "light",
    dominant: {
      900: "#eef3f6",
      800: "#b7bdc1",
      700: "#80878c",
      600: "#495157",
      main: "#121b22",
      400: "#0f191d",
      300: "#0d1519",
      200: "#0b1115",
      100: "#090d11",
    },
    complement: {
      900: "#edf4f8",
      800: "#bac9cf",
      700: "#879ca6",
      600: "#546f7d",
      main: "#214254",
      400: "#1c3545",
      300: "#152834",
      200: "#0e1b23",
      100: "#070e12",
    },
    accent: {
      900: "#f6f7ce",
      800: "#ecef9b",
      700: "#e2e669",
      600: "#d9de36",
      main: "#cfd604",
      400: "#a5ab03",
      300: "#7c8002",
      200: "#525502",
      100: "#292a01",
    },
    gray: {
      400: "#fafafa",
      300: "#ffffff",
      200: "#f5f5f5",
      100: "#ebebeb",
      50: "#e1e1e1",
      bg: "#d7d7d7",
    },
    dark: {
      10: "#666666",
      20: "#4d4d4d",
      30: "#333333",
      40: "#1a1a1a",
    },
    satisfaction: {
      100: "#14341b",
      95: "#21562d",
      90: "#2e783f",
      85: "#3c9a4f",
      80: "#ffa200",
      60: "#d61600",
    },
    others: {
      link: "#2b93f3",
      bg: "#f5f8fa",
      activeBg: "#ebf5ff",
      active: "#0088ff",
      doneBg: "#f0faf2",
      done: "#3c9a4f",
      pendingBg: "#fffbeb",
      pending: "#ffc107",
      deadlineBg: "#ffebeb",
      deadline: "#fc4d55",
      borderColor: "#ECEFF1",
      borderColor2: "#AFAFAF",
      paymentBg: "#f6f6f6",
      purple: "#800080",
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          textAlign: "right",
          direction: "rtl",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          width: "fit-content",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          paddingRight: '11px !important',
          paddingLeft: '32px',
        },
        icon: {
          right: "auto",
          left: 7, 
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'IRANYekanX';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Raleway'), local('Raleway-Regular'), url(${"../styles/fonts/woff2/IRANYekanX-Black.woff2"}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--gray-400)	",
          },
          // Border color when focused
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--accent-primary)", // Change this to your desired color
            outlineWidth: "1px",
          },
        },
        input: {
          padding: "11px", // Removes the padding
          fontSize: "13.17px",
          "&:focus": {
            outline: "1px solid var(--accent-primary)",
            borderRadius: "4px",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "var(--gray-bg)",
            padding: "0 0",
            fontSize: "11.24px",
            fontWeight: "400",
            border: "none",
            borderRadius: "4px",
            borderColor: "var(--gray-bg)",
            "&::placeholder": {
              fontSize: "13px",
            },
            "&:hover": {
              backgroundColor: "var(--gray-100)", // Hover color
            },
            "&.Mui-focused": {
              backgroundColor: "var(--gray-100)", // Color when focused
              outline: ".8px solid var(--accent-primary)",
              border: "none",
              outlineRadius: "4px",
            },
          },

          "& .MuiInputLabel-root.Mui-error": {
            color: "var(--satisfaction-60)",
          },
          "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
            {
              border: "3px solid var(--satisfaction-60)",
            },
          "& .MuiFormHelperText-root.Mui-error": {
            color: "var(--satisfaction-60)",
          },

          "& .MuiInputLabel-root": {
            borderColor: "var(--accent-primary)",
            background: "var(--gray-bg)",
          },
        },
      },
    },
    // MuiContainer: {
    // 	styleOverrides: {
    // 		root: {
    // 			maxWidth: "1440px !important",
    // 		},
    // 	},
    // },
    // MuiCard: {
    // 	styleOverrides: {
    // 		root: {
    // 			borderColor: "var(--accent-primary)",
    // 			background: "var(--accent-primary)",
    // 			borderWidth: 1,
    // 			borderStyle: "solid",
    // 		},
    // 	},
    // },
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: "var(--gray-50)",
        },
        indicator: {
          backgroundColor: "var(--dominant-primary)", // The color of the indicator (underline)
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "11.24px",
          fontWeight: "500",
          textTransform: "none", // Prevent text from being uppercase
          minHeight: "48px",
          "&.Mui-selected": {
            color: "var(--dark-40)", // Color when the tab is selected
            backgroundColor: "var(--gray-50)",
            fontWeight: "bold",
            border: "none",
          },
          "&:hover": {
            color: "var(--dominant-400)", // Color on hover
          },
        },
      },
    },

    MuiButton: MuiButton,
  },
});
